/** @file NewProjectBar: a name field and "New project" (a game that will hold puppets). */
import { useState } from 'react';
import type { ReactElement } from 'react';
import { useEditorStore } from '../state/useEditorStore';
import { asPose3DError } from '../store/asPose3DError';
import type { EditorApi } from '../store/editorApi';
import { errorText } from '../store/errorText';
import { Button } from '../ui-kit/Button';

/** Creates a project and opens its (empty) puppets list. */
export function NewProjectBar({ api }: { api: EditorApi }): ReactElement {
  const store = useEditorStore();
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const create = (): void => {
    setBusy(true);
    api.projects.create({ name: name.trim() }).then((p) => { store.getState().navigate({ screen: 'puppets', projectId: p.id }); }, (e: unknown) => {
      setBusy(false);
      store.getState().notify('error', errorText(asPose3DError(e)));
    });
  };
  return (
    <div className="p3-row">
      <input className="p3-input" aria-label="New project name" placeholder="Game name" value={name}
        onChange={(e) => { setName(e.target.value); }} />
      <Button variant="primary" disabled={name.trim() === '' || busy} onClick={create}>New project</Button>
    </div>
  );
}
